// src/tieredPricing/tieredPricing.ts
var TIERED_CU_PRICING = {
  [0 /* FREE */]: [{ min: 0, price: 0 }],
  [1 /* GROWTH */]: [{ min: 0, price: 12e-7 }],
  [4 /* SCALE */]: [{ min: 0, price: 1e-6 }],
  [5 /* PAYG */]: [
    { min: 0, max: 3e8, price: 0.45 * 1e-6 },
    { min: 3e8, price: 0.4 * 1e-6 }
  ]
};
var TEAM_ID_TIERED_CU_PRICING_OVERRIDES = {
  2: [
    // OpenSea
    { min: 0, max: 25e9, price: 63e-8 },
    { min: 25e9, price: 1e-6 }
  ]
};

export {
  TIERED_CU_PRICING,
  TEAM_ID_TIERED_CU_PRICING_OVERRIDES
};
//# sourceMappingURL=chunk-FOZMR2JX.mjs.map